import type { Translations } from './en';

export const de: Translations = {
  common: {
    myTrips: 'Meine Reisen',
    settings: 'Einstellungen',
    signIn: 'Anmelden',
    signOut: 'Abmelden',
    signedIn: 'Angemeldet',
    account: 'Konto',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestatigen',
    loading: 'Laden...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Loschen',
    back: 'Zuruck',
    close: 'Schliessen',
    copy: 'Kopieren',
    view: 'Ansehen',
    navigate: 'Navigieren',
    copiedToClipboard: 'In die Zwischenablage kopiert!',
    explore: 'Entdecken',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    coachInstantSave: 'Tippe um diesen Ort in deine Reise zu speichern',
    share: 'Teilen',
    updateAvailableTitle: 'Neue Version verfügbar',
    updateAvailableBody: 'Aktualisiere, um die neueste Version von TripBoom zu laden. Nicht gespeicherte Änderungen können verloren gehen.',
    refresh: 'Aktualisieren',
  },

  input: {
    interestedIn: 'Interessiert an..',
    tagline: 'Deine Stadt, deine Zeit, auf deine Art.',
    whereAreYou: 'Wo bist du?',
    locationPlaceholder: 'Stadt oder Viertel...',
    pleaseEnterLocation: 'Bitte gib einen Ort ein',
    useMyCurrentLocation: 'Meinen aktuellen Standort verwenden',
    locationErrorRetry: 'Erneut versuchen',
    locationErrorEnterManually: 'Oder manuell eingeben',
    howLong: 'Wie viel Zeit hast du?',
    howGettingAround: 'Wie bewegst du dich fort?',
    imFeeling: 'Ich fühle mich...',
    pleaseSelectVibe: 'Bitte wahle mindestens eine Stimmung',
    findMyAdventure: 'Mein Abenteuer finden',
    placesFiltered: '{count} Ort{s} gefiltert - jetzt nicht geoffnet',
    includeClosedPlaces: 'Geschlossene Orte einbeziehen',
  },

  share: {
    title: 'TripBoom teilen',
    message: 'Diese App hat mir den ganzen Tag in 10 Sekunden geplant \u2014 Restaurants, Bars, Aktivit\u00E4ten. Probier\u2019s aus \uD83D\uDC47',
    copyLink: 'Link kopieren',
    copied: 'Kopiert!',
    shareOn: 'Teilen auf',
    twitter: 'X',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    email: 'E-Mail',
    shareWithFriendTitle: 'Mit einem Freund teilen',
    earnSubtitle: 'Verdiene +2 Interessen- und +2 AI-High-Suchen, wenn sie sich anmelden — oder lass deinen Freund den QR scannen.',
    scanSubtitle: 'Scannen, um TripBoom auf einem anderen Gerät zu öffnen',
    shareNow: 'Jetzt teilen',
    shareViaQrAria: 'Tippen zum Teilen von TripBoom',
    shareMessage: 'Probier TripBoom — dein KI-Reisekonzierge. Nutze meinen Link oder scanne den QR: {url}',
  },

  time: {
    '1-2-hrs': '1-2 Std',
    'half-day': 'Halber Tag',
    'full-day': 'Ganzer Tag',
    '2-3-days': '2-3 Tage',
  },

  transport: {
    walking: 'Zu Fuss',
    transit: 'ÖPNV',
    taxi: 'Taxi/Auto',
  },

  vibes: {
    hungry: 'Hungrig',
    adventurous: 'Abenteuerlustig',
    'must-sees': 'Sehenswert',
    'feeling-lucky': 'Auf gut Glück',
    popular: 'Beliebt',
    'hidden-gems': 'Geheimtipp',
  },

  travel: {
    nearby: 'In der Nähe',
    rightHere: 'Direkt hier',
    minWalk: '{n} Min. zu Fuß',
    minTransit: '~{n} Min. mit Bus/Bahn',
    minDrive: '~{n} Min. Fahrt',
    mins: '{n} Min.',
    hrMins: '{h} Std. {m} Min.',
    localSpot: 'Lokaler Ort',
  },

  results: {
    placesFound: '{count} Empfehlungen',
    findMorePlaces: 'Mehr Orte finden',
    searchingWiderArea: 'Suche in grosserem Gebiet...',
    placesSelected: '{count} Ort{s} ausgewahlt',
    saveTrip: 'Reise speichern',
    viewTrip: 'Reise ansehen',
    saving: 'Speichern...',
    saved: 'Gespeichert',
    iWannaGo: 'Da will ich hin!',
    address: 'Adresse',
    hoursToday: 'Offnungszeiten heute',
    visitWebsite: 'Website besuchen',
    copyHookLabel: 'Notizen',
    copyTravelLabel: 'Anreise',
    copyMapsLabel: 'Google Maps',
    showingFiltered: '{filtered} von {total} angezeigt',
    showingAll: 'Alle anzeigen',
    offlineRankingBanner: 'KI nicht verfügbar — sortiert nach Bewertung, Entfernung und Öffnungszeiten.',
  },

  loadingStages: {
    checkingLocation: 'Standort wird gepruft',
    checkingLocationNamed: '{name} wird gepruft',
    discoveringPlaces: 'Orte entdecken',
    searchesComplete: '{completed}/{total} Suchen abgeschlossen',
    searchingCustomVibe: 'Suche benutzerdefinierte Stimmung...',
    mergingResults: 'Ergebnisse zusammenfuhren...',
    deepSearching: 'Tiefensuche nach Geheimtipps',
    findingMore: 'Mehr Optionen finden',
    sortingByRating: 'Sortierung nach Bewertung und Entfernung',
    aiMatchingVibes: 'KI passt Stimmungen an',
    aiAnalysing: 'KI analysiert deine Optionen',
    sendingToAi: 'Wird an KI gesendet...',
    processingResponse: 'Antwort wird verarbeitet...',
    filteringResults: 'Ergebnisse werden gefiltert...',
    analysedEliminated: '{analysed} analysiert, {eliminated} aussortiert',
  },

  poi: {
    moreLikeThis: 'Mehr davon',
    lessLikeThis: 'Weniger davon',
    moreLikeThisConfirm: 'Mehr davon',
    lessLikeThisConfirm: 'Weniger davon',
    cleared: 'Geloscht',
    open: 'Geoffnet',
    closed: 'Geschlossen',
    likelyOpen: 'Wahrscheinlich geoffnet',
    likelyClosed: 'Wahrscheinlich geschlossen',
    easy: 'Einfach',
    doable: 'Machbar',
    far: 'Weit',
    travelTimeEstimate: 'Grobe Schatzung basierend auf Entfernung — tatsachliche Reisezeit kann abweichen',
    travelTimeGoogle: 'Reisezeit von Google Maps',
    foundOnTripBoom: 'Gefunden auf TripBoom, dein KI-Reiseassistent — tripboom.app',
  },

  cancel: {
    takingABreak: 'Eine Pause?',
    pauseDescription: 'Pausiere statt zu kundigen — dein Geschmacksprofil und gespeicherte Reisen bleiben sicher.',
    proActiveUntil: 'Pro aktiv bis {date}',
    pauseMonths: '{count} Monat pausieren',
    pauseMonthsPlural: '{count} Monate pausieren',
    resumesOn: 'Wird am {date} fortgesetzt',
    resumeAnytime: 'Jederzeit fortsetzen',
    pauseIndefinitely: 'Unbegrenzt pausieren',
    resumeWhenReady: 'Fortsetzen wenn bereit',
    resumeFromSettings: 'Du kannst jederzeit uber Einstellungen fortsetzen. Deine Daten werden immer aufbewahrt.',
    cancelInstead: 'Abonnement kundigen',
    confirmTitle: 'Pro kündigen?',
    confirmBody: 'Pro bleibt bis {date} aktiv, danach wechselt dein Konto zum kostenlosen Plan. Gespeicherte Reisen und dein Geschmacksprofil bleiben erhalten.',
    confirmBodyNoDate: 'Dein Konto wechselt zum kostenlosen Plan. Gespeicherte Reisen und dein Geschmacksprofil bleiben erhalten.',
    keepPro: 'Pro behalten',
    confirmCancel: 'Pro kündigen',
  },

  installBanner: {
    addToHomeScreen: 'Zum Startbildschirm hinzufugen',
    fileToDock: 'Zum Dock hinzufugen',
    bestExperience: 'beste Erfahrung',
    install: 'Installieren',
    dismiss: 'Schliessen',
  },

  loading: {
    messages: [
      'Suche in der Nähe...',
      'Prüfe Öffnungszeiten...',
      'Filtere nach Entfernung...',
      'Prüfe Bewertungen...',
      'Finde Geheimtipps...',
      'Passe Vibes an...',
      'Sortiere Ergebnisse...',
      'Fragen die Einheimischen...',
      'Filtern Touristenfallen...',
      'Finden die guten Sachen...',
      'Fast fertig...',
    ],
  },

  settings: {
    title: 'Einstellungen',
    aiMode: 'KI-Unterstutzung',
    aiModeDescription: 'KI verwenden, um Ergebnisse zu priorisieren, anzureichern und zu beschreiben',
    aiOffNotice: 'KI ist deaktiviert. Ergebnisse werden nach Bewertung und Entfernung sortiert. Beschreibungen verwenden nur Google-Daten.',
    aiLevelPrompt: 'Wahle dein KI-Unterstutzungslevel:',
    aiLevels: {
      off: 'Aus',
      low: 'Niedrig',
      medium: 'Mittel',
      high: 'Hoch',
    },
    aiLevelDescriptions: {
      low: 'Schnelles Vibe-Matching, Basis-Ranking',
      medium: 'Reisezeiten, Praxisbewertungen',
      high: 'Breitere Suche, tiefere Geschmacksanalyse',
    },
    showOnlyOpenPlaces: 'Nur geöffnete Orte anzeigen',
    filterClosedPlaces: 'Geschlossene Orte bei kurzen Zeitfenstern ausblenden',
    minimumStarRating: 'Mindestbewertung',
    onlyShowRatingOrHigher: 'Nur Orte mit dieser Bewertung oder höher anzeigen',
    any: 'Alle',
    searchDistance: 'Suchentfernung',
    adjustSearchDistance: 'Passe die Suchentfernung fur jede Transport- und Zeitkombination an.',
    placeCategories: 'Ortskategorien',
    categoriesUsedWhenAIFails: 'Kategorien werden verwendet, wenn die KI nicht klassifizieren kann.',
    settingsSessionOnly: 'Deine Filter gelten nur für diese Sitzung und werden beim Neuladen zurückgesetzt. Melde dich an, um sie zu behalten.',
    settingsSavedLoggedIn: 'Einstellungen werden nur fur angemeldete Benutzer gespeichert.',
    signInToSave: 'Melde dich an, um deine Reisen zu speichern',
    installApp: 'App installieren',
    installAppDescription: 'Fuge TripBoom zu deinem Startbildschirm hinzu fur schnellen Zugriff',
    install: 'Installieren',
    tripGrouping: 'Reisen gruppieren nach',
    tripGroupingDescription: 'Wahle, wie deine gespeicherten Reisen organisiert werden',
    groupByDay: 'Tag',
    groupByLocation: 'Ort',
    filters: 'Filter',
    upgradeToPremium: 'Pro holen',
    unlimitedTripsDescription: 'Unbegrenzte Speicherungen, Suchen & AI-High-Modus',
    upgrade: 'Upgraden',
    premiumMember: 'Pro-Mitglied',
    lifetimeAccess: 'Lebenslanger Zugang zu unbegrenzten Funktionen & Speichern',
    yearlyAccess: 'Jahrlicher Zugang zu unbegrenzten Funktionen & Speichern',
    appearance: 'Darstellung',
    theme: 'Thema',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    themeSystem: 'System',
    tasteProfile: 'Geschmackskarte',
    interactions: 'Interaktionen',
    tripsPlanned: 'geplante Reisen',
    topCategories: 'Top-Kategorien',
    topVibes: 'Top-Stimmungen',
    tasteImproves: 'Deine Empfehlungen verbessern sich mit jeder Interaktion',
    topInterests: 'Top-Interessen',
    travelStyle: 'Reisestil',
    prefersNearby: 'Bevorzugt Nahes',
    prefersExploring: 'Liebt es weit zu erkunden',
    mixedExplorer: 'Gemischter Entdecker',
    prefersMixed: 'Gemischter Entdecker',
    subscribe: 'Abonnieren',
    premiumAccess: 'Pro abonnieren',
    premiumSupporter: 'Pro-Mitglied',
    monthlyAccess: 'Monatlicher Zugang zu unbegrenzten Funktionen & Speichern',
    getProCTA: 'Pro holen — Unbegrenzte Reisen und Credits',
    yourBenefits: 'Deine Vorteile',
    yourCredits: 'Deine Credits',
    freeCredits: 'Deine kostenlosen Credits',
    freeCreditsOnReg: 'Deine kostenlosen Credits — bei Registrierung',
    dayGroups: 'Tagesgruppen',
    locationGroups: 'Ortsgruppen',
    interestSearches: 'Interesse-Suchen',
    highAiSearches: 'AI-High-Suchen',
    unlimited: 'Unbegrenzt',
    perMonth: '/Monat',
    unlimitedInterestSearches: 'Unbegrenzte Interesse-Suchen',
    unlimitedInterestSearchesFull: 'Unbegrenzte "Interessiert mich..."-Suchen',
    savedInterestsBenefit: 'Gespeicherte Interessen — personalisiere jede Suche',
    unlimitedGroups: 'Unbegrenzte Tages-/Ortsgruppen',
    unlockArchived: 'Archivierte Reisen freischalten',
    feedbackViaWebsite: 'Feedback uber die Website ↗',
    privacyAndData: 'Datenschutz & Daten ↗',
    contactSupport: "Support kontaktieren",
    deleteAccount: "Mein Konto löschen",
    deleteAccountTitle: "Konto löschen?",
    deleteAccountBody: "Dadurch werden dein Konto, deine gespeicherten Trips, geteilten Links, dein Geschmacksprofil und deine Guthaben endgültig gelöscht. Das lässt sich nicht rückgängig machen.",
    deleteAccountCancel: "Konto behalten",
    deleteAccountConfirm: "Endgültig löschen",
    deleteAccountDeleting: "Wird gelöscht…",
    deleteAccountDone: "Dein Konto und deine Daten wurden gelöscht.",
    deleteAccountFailed: "Dein Konto konnte gerade nicht gelöscht werden. Versuch es noch einmal oder schreib an support@tripboom.app.",
    deleteAccountActiveSub: "Du hast ein aktives bezahltes Abo. Kündige es zuerst, damit nichts mehr abgebucht wird, und lösche dann dein Konto.",
    deleteAccountAdmin: "Admin-Konten können nicht in der App gelöscht werden.",
    pauseFrozenResume: 'Zahlung eingefroren — fortsetzen um Pro zu reaktivieren',
    pauseFrozenActiveUntil: 'Zahlung eingefroren — Pro aktiv bis {date}',
    pauseFrozenExpires: 'Zahlung eingefroren — Pro lauft ab, wird fortgesetzt am {date}',
    pauseFrozenActiveResumes: 'Zahlung eingefroren — Pro aktiv bis {date}, wird fortgesetzt am {resumeDate}',
    yearlyActive: 'Jahrlich — Aktiv',
    monthlyActive: 'Monatlich — Aktiv',
    tripPassActive: 'Reise-Pass — Aktiv',
    tripPassExpired: 'Reise-Pass — abgelaufen',
    tripPassDaysLeft: 'Reise-Pass — {count} Tag{s} ubrig',
    yearlyRenews: 'Jahrlich — erneuert am {date}',
    monthlyRenews: 'Monatlich — erneuert am {date}',
    tipConcierge: 'Dem Concierge ein Trinkgeld geben',
    tipConciergeDescription: 'Hattest du einen guten Ausflug? Ein Trinkgeld hilft uns weiterzumachen...',
    tipButton: 'Trinkgeld',
    tripPassAccess: 'Reise-Pass — aktiv',
    tripPassLastDay: 'Trip Pass — letzter Tag!',
    proPaused: 'Pro pausiert',
    proEnabled: 'Pro aktiviert',
    proSubtitleFree: 'Unbegrenzte Suchen, Speichern, Credits & KI',
    upsellFromTripPass: 'Spare mit einem Abo für unbegrenzte Credits auf jeder Reise',
    upsellFromMonthly: 'Wechsel zu Jährlich und spare über 50%',
  },

  auth: {
    welcomeBack: 'Willkommen zuruck',
    createAccount: 'Konto erstellen',
    signInDescription: 'Melde dich an, um deine Reisen auf allen Geräten zu speichern und darauf zuzugreifen',
    iHaveAccount: 'Ich habe ein Konto',
    imNewHere: 'Ich bin neu hier',
    emailPlaceholder: 'du@beispiel.de',
    passwordPlaceholder: 'Gib dein Passwort ein',
    passwordMinChars: 'Mindestens 6 Zeichen',
    confirmPasswordPlaceholder: 'Passwort erneut eingeben',
    pleaseEnterEmail: 'Bitte gib deine E-Mail ein',
    pleaseEnterPassword: 'Bitte gib dein Passwort ein',
    passwordTooShort: 'Das Passwort muss mindestens 6 Zeichen haben',
    passwordsDoNotMatch: 'Die Passworter stimmen nicht uberein',
    signingIn: 'Anmeldung...',
    creatingAccount: 'Konto wird erstellt...',
    newHere: 'Neu hier?',
    createAnAccount: 'Ein Konto erstellen',
    alreadyHaveAccount: 'Hast du schon ein Konto?',
    installWebApp: 'Web-App installieren',
    somethingWentWrong: 'Etwas ist schief gelaufen',
    apiCostNote: 'TripBoom nutzt Premium-APIs, um deine perfekten Orte zu finden — kostenlos zu nutzen, aber bitte denk an ein Pro-Upgrade, um uns bei den Kosten zu helfen.',
    emailSignInLink: 'Anmeldelink per E-Mail senden',
    emailSignInLinkInstead: 'Stattdessen Anmeldelink per E-Mail senden',
    signInLinkTitle: 'Anmeldelink',
    signInLinkDescription: 'Gib deine E-Mail-Adresse ein, und wir senden dir einen Anmeldelink. Kein Passwort nötig.',
    sendSignInLink: 'Anmeldelink senden',
    checkYourEmail: 'Prüfe deine E-Mails',
    signInLinkSentBody: 'Tippe auf den Anmeldelink in deiner E-Mail, um dich anzumelden. Der Link funktioniert in jedem Browser, auch in diesem. Schau im Spam-Ordner nach, falls du ihn nicht siehst.',
    signInLinkOrCodeBody: "Tippe auf den Link in der E-Mail oder gib den Code unten ein. Du nutzt die installierte TripBoom-App? Nimm den Code: Links öffnen sich stattdessen im Browser. Schau im Spam-Ordner nach, falls du sie nicht siehst.",
    signInCodeLabel: "Anmeldecode",
    signInWithCode: "Mit Code anmelden",
    checkingCode: "Wird geprüft…",
    enterCodeFromEmail: "Gib den Code aus der E-Mail ein.",
    codeInvalid: "Dieser Code hat nicht funktioniert. Er ist vielleicht abgelaufen oder wurde schon benutzt; fordere einen neuen an.",
    forgotPassword: 'Passwort vergessen?',
    resetPassword: 'Passwort zurucksetzen',
    emailSent: 'E-Mail gesendet',
    resetDescription: 'Gib deine E-Mail ein und wir senden dir einen Link zum Zurucksetzen deines Passworts.',
    sending: 'Wird gesendet...',
    sendResetLink: 'Link senden',
    resetLinkSent: 'Zurucksetzungslink gesendet',
    checkEmailForReset: 'Prufe deine E-Mail fur den Zurucksetzungslink. Prufe den Spam-Ordner, falls du ihn nicht siehst.',
    done: 'Fertig',
    continueWithGoogle: 'Mit Google fortfahren',
    googleSignInFailed: 'Google-Anmeldung fehlgeschlagen',
    or: 'oder',
    migrationNotice: 'Beta-Nutzer, die sich vor dem {date} registriert haben, mussen ein neues Konto erstellen — Entschuldigung fur die Unannehmlichkeiten!',
  },

  savedTrips: {
    title: 'Gespeicherte Reisen',
    tripSaved: 'Reise gespeichert!',
    noSavedTrips: 'Noch keine gespeicherten Reisen',
    selectPlacesPrompt: 'Wähle Orte aus und speichere deine Reise, um sie hier zu sehen',
    backToAllTrips: 'Zuruck zu allen Reisen',
    backToPlanning: 'Planung',
    newSearch: 'Neue Suche',
    mergeTrips: 'Zusammenfuhren',
    selectTrips: 'Reisen wahlen',
    merge: 'Zusammenfuhren',
    showAllTrips: 'Alle Reisen anzeigen',
    places: 'Orte',
    deleteGroup: 'Gruppe loschen',
    deleteGroupConfirm: 'Alle Reisen in dieser Gruppe loschen?',
    groupLimitReached: 'Du hast das kostenlose Limit erreicht. Losche eine Gruppe oder upgrade, um mehr Reisen zu speichern.',
    trips: 'Reisen',
    addToTrip: 'Zur Reise hinzufugen',
    newSuggestions: 'Neue Vorschlage - auswahlen zum Hinzufugen',
  },

  itinerary: {
    title: 'Deine Reiseroute',
  },

  resetPassword: {
    verifying: 'Dein Link wird geprüft...',
    linkExpired: 'Link abgelaufen oder ungültig',
    linkExpiredBody: 'Links zum Zurücksetzen des Passworts laufen nach 1 Stunde ab. Fordere im Anmeldebildschirm einen neuen an.',
    backToTripBoom: 'Zurück zu TripBoom',
    updated: 'Passwort aktualisiert!',
    updatedBody: 'Du bist jetzt mit deinem neuen Passwort angemeldet.',
    goToTripBoom: 'Zu TripBoom',
    setNew: 'Neues Passwort festlegen',
    setNewBody: 'Wähle etwas Sicheres — mindestens 6 Zeichen.',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    atLeast6: 'Mindestens 6 Zeichen',
    repeatPassword: 'Passwort wiederholen',
    saving: 'Wird gespeichert...',
    submit: 'Neues Passwort speichern',
    tooShort: 'Das Passwort muss mindestens 6 Zeichen haben',
    mismatch: 'Die Passwörter stimmen nicht überein',
  },

  errors: {
    noOpenPlacesFound: 'Keine geoffneten Orte gefunden. {count} Orte sind derzeit geschlossen.',
    noPlacesFound: 'Keine Orte gefunden, die deinen Kriterien entsprechen. Versuche deine Suche anzupassen.',
    searchUnavailable: "Unser Suchdienst ist gerade nicht erreichbar. An deiner Suche lag es nicht; versuch es gleich noch einmal.",
    unableToRank: 'Orte konnten nicht bewertet werden. Bitte versuche es erneut.',
    genericError: 'Fehler: {message}. Bitte versuche es erneut oder passe deine Suchkriterien an.',
    locationNotFound: 'Dieser Ort wurde nicht gefunden. Bitte prüfe die Schreibweise und versuche es erneut.',
    signInForInterest: 'Melde dich an, um weitere „Interessiert an…“-Suchen freizuschalten. Kostenlos!',
    creditsExhaustedBody: 'Du hast deine Interessen-Suchen für diesen Monat aufgebraucht — gut erkundet! Verdiene mehr, indem du in der App teilst, oder hol dir Pro für unbegrenzte Suchen.',
    dismiss: 'Schließen',
    goPro: 'Pro holen',
  },

  payment: {
    upgradeFailed: "Das hat nicht geklappt. Es wurde nichts abgebucht; bitte versuch es noch einmal.",
    unlockUnlimited: 'Unbegrenzte Reisen & Credits',
    upgradeDescription: 'Speichere so viele Reisen wie du mochtest, organisiert wie du willst',
    limitReached: 'Gruppenlimit erreicht',
    dayLimitReached: 'Du hast {current} von {max} Tagesgruppen',
    locationLimitReached: 'Du hast {current} von {max} Ortsgruppen',
    bothLimitsReached: 'Du hast {maxDays} Tagesgruppen und {maxLocations} Ortsgruppen',
    whatYouGet: 'Was du bekommst',
    unlimitedDayGroups: 'Unbegrenzte Tagesgruppen',
    unlimitedLocationGroups: 'Unbegrenzte Ortsgruppen',
    saveUnlimitedTrips: 'Unbegrenzt Reisen fur immer speichern',
    aiHighMode: 'KI Hoch — zusätzliche Suchen & bessere Geschmacksübereinstimmung',
    monthly: 'Monatlich',
    billedMonthly: 'Monatlich abgerechnet — jederzeit kundbar',
    yearly: 'Jahrlich',
    billedAnnually: 'Jahrlich abgerechnet — jederzeit kundbar',
    perMonth: '/Monat',
    perYear: '/Jahr',
    bestValue: 'BESTES ANGEBOT',
    tripPass: 'Reise-Pass',
    tripPassDescription: '7 Tage Pro — kaufen Sie wenn Sie reisen',
    oneOff: 'einmalig',
    whyWeCharge: 'Google berechnet uns jedes Mal, wenn wir die Basisdaten nutzen, die in Maps kostenlos sind. Wir fugen KI, Geschmackslernen, Praxispriorisierung und mehr hinzu. Wir durfen Google-Daten nur wenige Tage speichern. Teile diese App mit anderen — und deine finanzielle Unterstutzung halt uns am Laufen. Und wir finden das cool.',
    upgradeNow: 'Jetzt upgraden',
    processing: 'Verarbeitung...',
    customTip: 'Trinkgeld für den Concierge',
    customTipDescription: 'Eine Spende, um uns beim Aufbau zu helfen',
    tipNow: 'Betrag oben eingeben',
    thankYou: 'Vielen herzlichen Dank!',
    securePayment: 'Sicherer Checkout',
    upgradeSuccess: 'Willkommen bei TripBoom Pro!',
    premiumFeature: 'Pro',
    whyWeChargeTitle: 'Warum hat TripBoom eine Pro-Stufe?',
    billedAnnuallyNeutral: 'Ideal für Vielreisende',
    billedMonthlyNeutral: 'Flexibel — jederzeit kündbar',
    betaBannerTitle: 'Beta-Zugang — alle Pro-Funktionen sind kostenlos',
    betaBannerBody: 'Es fallen keine Gebühren an. Aktiviere, um alles freizuschalten.',
    activateFreeBeta: 'Kostenlose Beta aktivieren',
    betaActivate: 'Sofort aktiviert — keine Zahlung erforderlich',
  },
  categories: {
    restaurant: 'Restaurant',
    cafe: 'Cafe',
    bakery: 'Backerei',
    bar: 'Bar',
    meal_takeaway: 'Essen zum Mitnehmen',
    meal_delivery: 'Lieferservice',
    fast_food_restaurant: 'Schnellrestaurant',
    coffee_shop: 'Kaffeehaus',
    tourist_attraction: 'Sehenswurdigkeit',
    museum: 'Museum',
    art_gallery: 'Kunstgalerie',
    church: 'Kirche',
    hindu_temple: 'Hindu-Tempel',
    mosque: 'Moschee',
    synagogue: 'Synagoge',
    park: 'Park',
    amusement_park: 'Freizeitpark',
    aquarium: 'Aquarium',
    zoo: 'Zoo',
    performing_arts_theater: 'Theater',
    cultural_center: 'Kulturzentrum',
    national_park: 'Nationalpark',
    campground: 'Campingplatz',
    hiking_area: 'Wandergebiet',
    marina: 'Yachthafen',
    sports_club: 'Sportverein',
    sports_complex: 'Sportkomplex',
    stadium: 'Stadion',
    ski_resort: 'Skigebiet',
    athletic_field: 'Sportplatz',
    bowling_alley: 'Bowlingbahn',
    book_store: 'Buchhandlung',
    night_club: 'Nachtclub',
    liquor_store: 'Spirituosenladen',
    market: 'Markt',
    shopping_mall: 'Einkaufszentrum',
    casino: 'Casino',
    spa: 'Spa',
    movie_theater: 'Kino',
  },

  referral: {
    friendShared: 'Ein Freund hat TripBoom mit dir geteilt!',
    signUpNudge: 'Melde dich an, um deine kostenlosen Suchen freizuschalten — und deinem Freund Bonuskredite zu verdienen.',
    signUpFree: 'Kostenlos anmelden',
    maybeLater: 'Vielleicht später',
    totalsLine: '{count} Freunde beigetreten · +{interest} Interesse · +{deep} KI Hoch',
    recentJoinersAria: 'Neueste Beigetretene anzeigen',
  },

  pin: {
    pinAria: 'Diese Reise zu deinem Plan hinzufügen',
    unpinAria: 'Diese Reise aus deinem Plan entfernen',
    pinPlanLabel: 'An Plan heften',
    pinTripToPlanLabel: 'An Plan heften',
    pinnedLabel: 'Angeheftet',
    yourPlanLabel: 'Dein Plan',
    emptyHint: 'Öffne eine gespeicherte Reise und tippe auf "An Plan heften", um sie als aktiven Plan zu markieren. Bis zu zwei können gleichzeitig angeheftet sein.',
    emptyHintAria: 'Wie man eine Reise anheftet',
    mergePlan: 'Plan zusammenführen',
    mergePlanAria: 'Deine beiden angehefteten Reisen zu einem Plan zusammenführen',
  },

  toasts: {
    welcome: 'Willkommen bei TripBoom! Fang an zu entdecken',
    firstShare: 'Deine erste geteilte Reise!',
    firstSaveBonus: 'Willkommen! +5 Interessensuchen und 3 AI-High-Suchen freigeschaltet',
    saveFailed: 'Wir konnten diese Reise nicht speichern. Bitte versuche es erneut.',
    renamed: 'Reise umbenannt.',
    linkCopied: 'Link kopiert.',
    deleteFailed: 'Löschen fehlgeschlagen. Bitte versuche es erneut.',
    renameFailed: 'Umbenennen fehlgeschlagen. Bitte versuche es erneut.',
    addPlacesFailed: 'Die Orte konnten nicht hinzugefügt werden. Bitte versuche es erneut.',
    loadFailed: 'Deine Trips konnten nicht geladen werden. Angezeigt wird der letzte Stand.',
    cancelDone: 'Abo gekündigt.',
    cancelFailed: 'Kündigung fehlgeschlagen. Bitte versuche es erneut.',
    pauseFailed: 'Pausieren fehlgeschlagen. Bitte versuche es erneut.',
    resumeFailed: 'Fortsetzen fehlgeschlagen. Bitte versuche es erneut.',
    refundFailed: 'Keine Treffer, und die Gutschrift ist fehlgeschlagen. Bitte kontaktiere den Support.',
    interestCreditRefunded: "Diese Suche hat nichts gefunden, dein Interessen-Guthaben ist zurück.",
    subscriptionExpiredTitle: 'Dein Abo ist abgelaufen',
    subscriptionExpiredBody: 'Abonniere erneut für unbegrenzte Suchen, Speichern und KI-Funktionen.',
    subscriptionExpiredCTA: 'Pläne ansehen',
    dismiss: 'Schließen',
    referralReward: 'Dein Freund hat +{interest} Interessensuchen und {deep} AI-High-Suchen erhalten!',
    noAiHighCredits: 'Keine AI-High-Guthaben — auf Mittel umgestellt',
    aiHighLeft: 'AI High ({count} übrig)',
  },

  reevaluate: {
    headerButton: 'Tunen',
    heroBannerTitle: 'Diese Orte für deinen Kontext tunen',
    heroBannerSubtitle: 'Sortiere nach deinem Standort, deiner Fortbewegung und deiner verfügbaren Zeit',
    heroBannerCta: 'Diese Orte für deinen Kontext tunen',
    title: 'Diese Orte tunen',
    langLabel: 'Sprache:',
    subtitle: 'Sortiere diese Orte nach deinem Kontext — wo du bist, wie du dich fortbewegst und wie viel Zeit du hast.',
    locationLabel: 'Standort',
    locationOriginal: 'Original',
    locationCurrent: 'Aktuell',
    submitButton: 'Tunen',
    reevaluating: 'Wird getunt…',
    bannerTitle: 'Für dich getunt',
    bannerSubtitle: 'Neu sortiert nach deinem Kontext: {transport}, {time}.',
    offlineBannerTitle: 'KI nicht verfügbar',
    offlineBannerSubtitle: "Sortiert nach Bewertung, Entfernung und Öffnungszeiten für: {transport}, {time}.",
    clear: 'Zurücksetzen',
    saveCta: 'Reise in meinem Konto speichern',
    currentLocationLabel: 'Dein aktueller Standort',
    noCoordinatesError: 'Diese Reise hat keine Standortdaten — wähle stattdessen Aktuell.',
    geoUnsupportedError: 'Dein Browser unterstützt keine Standortdienste.',
    geoPermissionError: 'Standortzugriff verweigert. Wähle Original.',
    geoFailedError: 'Standort konnte nicht abgerufen werden. Wähle Original.',
    genericError: 'Tunen fehlgeschlagen. Bitte erneut versuchen.',
    toastSaved: 'Reise gespeichert! Heften an, wenn du sie hervorheben möchtest.',
    toastSavedAndPinned: 'Reise gespeichert und an deinen Plan geheftet!',
    savedTripButtonLabel: 'Tunen',
    savedTripButtonTitle: 'Tunen',
    savedTripButtonAria: 'Diese Reise für einen neuen Kontext tunen',
    savedTripBannerTitle: 'Getunt',
    savedTripSave: 'Als neue Reise speichern',
    savedTripSaveAria: 'Diese getunte Reise als neue Reise speichern',
    savedTripDiscard: 'Verwerfen',
    savedTripDiscardAria: 'Tuning verwerfen und zur ursprünglichen Reihenfolge zurückkehren',
  },

  sharedTrip: {
    loadingTrip: 'Reise wird geladen...',
    tripNotFound: 'Reise nicht gefunden',
    tripNotFoundDesc: 'Diese Reise wurde möglicherweise entfernt oder der Link ist falsch.',
    loadFailed: 'Diese Reise konnte nicht geladen werden',
    loadFailedDesc: 'Beim Laden ist etwas schiefgelaufen. Die Reise ist vielleicht noch da, bitte versuche es erneut.',
    retry: 'Erneut versuchen',
    placesCount: '{count} Orte · Tippen zum Erkunden',
    ctaButton: 'TripBoom testen — kostenlos',
    madeWith: 'Erstellt mit TripBoom, dein KI-Reiseassistent',
    aboutTagline: 'Dein KI-Reiseassistent. Sag ihm, worauf du Lust hast.',
    featureSearch: 'Stimmungssuche',
    featureSearchDesc: 'Suche nach Stimmung, nicht nach Stichworten',
    featureAI: 'KI-Ranking',
    featureAIDesc: 'Ergebnisse abgestimmt auf deinen Geschmack',
    featureSave: 'Speichern & Teilen',
    featureSaveDesc: 'Erstelle Reisen und teile sie wie diese hier',
    featureFree: 'Kostenlos',
    featureFreeDesc: 'Kein Konto nötig zum Starten',
    linkFeatures: 'Funktionen',
    linkPricing: 'Preise',
    linkInstall: 'Installieren',
  },
};
